import { Users, PieChart, Briefcase, Monitor, FileText } from 'lucide-react';

export const getIcon = (iconName) => {
  const iconMap = { Users, PieChart, Briefcase, Monitor };
  const Icon = iconMap[iconName] || FileText;
  return <Icon size={24} />;
};

export const copyToClipboard = (text, onSuccess) => {
  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(text).then(onSuccess).catch(() => {
      fallbackCopy(text, onSuccess);
    });
  } else {
    fallbackCopy(text, onSuccess);
  }
};

const fallbackCopy = (text, onSuccess) => {
  const textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.opacity = '0';
  document.body.appendChild(textArea);
  textArea.select();
  try {
    document.execCommand('copy');
    onSuccess?.();
  } catch (err) {}
  document.body.removeChild(textArea);
};
